var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { oncontextmenu: "return false;" } },
    [
      _c(
        "b-navbar",
        { staticClass: "d-flex", staticStyle: { "background-color": "gray" } },
        [
          _c(
            "div",
            {
              staticClass: "d-flex mx-auto",
              staticStyle: { "flex-direction": "rows" }
            },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "light",
                    disabled: _vm.rendering
                  },
                  on: { click: _vm.zoomOut }
                },
                [_vm._v("-")]
              ),
              _c(
                "div",
                {
                  staticClass: "d-flex mx-2 p-1",
                  staticStyle: {
                    "font-size": "13px",
                    background: "white",
                    color: "black",
                    "align-items": "center"
                  }
                },
                [_c("div", [_vm._v(_vm._s(Math.floor(_vm.scale * 100)) + "%")])]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "light",
                    disabled: _vm.rendering
                  },
                  on: { click: _vm.zoomIn }
                },
                [_vm._v("+")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { ref: "pdf", staticClass: "pdf-list" },
        _vm._l(_vm.numPages, function(n, i) {
          return _c("div", { key: i }, [
            _c("canvas", {
              staticClass: "d-flex mb-2 mx-auto",
              attrs: { id: _vm.getCanvasId(i) }
            })
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }